import React, { useState } from "react";
import { ICooperativeDetails } from "../../exports/interfaces";
import { formatDateBySetting } from "../../exports/functions";
import { useNavigate } from "react-router-dom";
import useMobile from "../../hooks/useMobile";
import { Eye, Pencil } from "lucide-react";
import { usePermission } from "../../hooks/usePermission";
import { useSettings } from "../../context/SettingsContext";
import DocumentPopUp from "../DocumentPopUp";

const getStatusClass = (status: string) => {
  switch (status) {
    case "Complete":
      return "pill-success";
    case "Inactive":
      return "pill-danger";
    case "Deactivated":
      return "bg-secondary";
    default:
      return "bg-secondary";
  }
};

const MemberInfo = ({
  cooperative,
}: {
  cooperative: ICooperativeDetails | null;
}) => {
  const [selectedDoc, setSelectedDoc] = useState<string | null>(null);
  const [showDoc, setShowDoc] = useState(false);
  const isMobile = useMobile();
  const { canEdit } = usePermission();
  const navigate = useNavigate();
  const { generalSettings } = useSettings();

  const handleOpenDoc = (url?: string | null) => {
    if (!url) return;
    setSelectedDoc(url);
    setShowDoc(true);
  };

  const renderViewAction = (url?: string | null) => (
    <div className="d-flex gap-3 align-items-center">
      <span
        onClick={() => handleOpenDoc(url)}
        style={{
          pointerEvents: url ? "auto" : "none",
          opacity: url ? 1 : 0.5,
          cursor: url ? "pointer" : "default",
        }}
      >
        <i
          className={url ? "cursor-pointer" : ""}
          data-toggle="tooltip"
          data-placement="top"
          title="View"
        >
          <Eye />
        </i>
      </span>
    </div>
  );

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h6 className="primary-color">Member list</h6>
        {canEdit("cooperatives") && (
          <button
            className="btn px-3 btn-badge fs-small"
            onClick={() =>
              navigate(`/register/edit/${cooperative?.id}`, {
                state: {
                  step: 4,
                },
              })
            }
          >
            <i className={`${!isMobile ? "me-2" : ""}`}>
              <Pencil size={15} />
            </i>
            {!isMobile && "Edit"}
          </button>
        )}
      </div>
      <div className="dashboard-card mt-3">
        <h6 className="text-uppercase mb-3">Upload History</h6>
        <div className="table-responsive admin-table table-checkbox">
          <table className="table align-middle">
            <thead>
              <tr>
                <th>Data Type</th>
                <th>Total Records</th>
                <th>Created Date</th>
                <th>Status</th>
                <th className="sticky-action">Action</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Share Members Data</td>
                <td>100</td>
                <td>
                  {cooperative?.shareMember?.createdAt
                    ? formatDateBySetting(
                        cooperative.shareMember.createdAt,
                        generalSettings?.dateFormat,
                      )
                    : "-"}
                </td>
                <td>
                  <span
                    className={`badge rounded-pill px-3 py-2 ${getStatusClass("Complete")}`}
                  >
                    Complete
                  </span>
                </td>

                <td className="sticky-action">
                  {renderViewAction(cooperative?.shareMember?.shareMemberUrl)}
                </td>
              </tr>
              <tr>
                <td>Saving Members Data</td>
                <td>100</td>
                <td>
                  {cooperative?.shareMember?.createdAt
                    ? formatDateBySetting(
                        cooperative.shareMember.createdAt,
                        generalSettings?.dateFormat,
                      )
                    : "-"}
                </td>
                <td>
                  <span
                    className={`badge rounded-pill px-3 py-2 ${getStatusClass("Complete")}`}
                  >
                    Complete
                  </span>
                </td>

                <td className="sticky-action">
                  {renderViewAction(cooperative?.shareMember?.savingMemberUrl)}
                </td>
              </tr>
              <tr>
                <td>Loan Members Data</td>
                <td>100</td>
                <td>
                  {cooperative?.shareMember?.createdAt
                    ? formatDateBySetting(
                        cooperative.shareMember.createdAt,
                        generalSettings?.dateFormat,
                      )
                    : "-"}
                </td>
                <td>
                  <span
                    className={`badge rounded-pill px-3 py-2 ${getStatusClass("Complete")}`}
                  >
                    Complete
                  </span>
                </td>

                <td className="sticky-action">
                  {renderViewAction(cooperative?.shareMember?.loanMemberUrl)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <hr />

      <DocumentPopUp
        showDoc={showDoc}
        setShowDoc={setShowDoc}
        docs={selectedDoc || undefined}
      />
    </>
  );
};

export default MemberInfo;
